import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { SelectData } from "../../../../../../../core/types/records-table.types";
import { AttachChatRecordCalenderIdParams } from "../../../../types/attach-chat-record-calender";
import { ChatTelegram } from "../../../../types/chat-telegram.types";
import { TelegramAccountsService } from "../../../../services/telegram-accounts.service";
import { TelegramService } from "../../../../services/telegram.service";
import { MatFormField, MatLabel } from "@angular/material/input";
import { MatOption, MatSelect } from "@angular/material/select";

@Component({
  selector: 'app-telegram-select-record-calendar-id',
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption
  ],
  templateUrl: './telegram-select-record-calendar-id.component.html',
  styleUrl: './telegram-select-record-calendar-id.component.scss'
})
export class TelegramSelectRecordCalendarIdComponent {
  @Input({ required: true }) recordCalenderIdSelectData: Array<SelectData> = [];
  @Input({ required: true }) recordCalendarId: number = 0;
  @Input({ required: true }) selectedChat: ChatTelegram | null = null;
  @Output() attachRecordCalendarId: EventEmitter<number> = new EventEmitter<number>();

  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);
  private telegramService: TelegramService = inject(TelegramService);

  public async handleChange(value: string): Promise<void> {
    if (!this.selectedChat) { return; }

    if (!value) {
      this.attachRecordCalendarId.emit(0);
      return;
    }

    const attachChatRecordCalenderIdParams: AttachChatRecordCalenderIdParams = {
      chatId: this.selectedChat.id,
      accountId: this.telegramAccountsService.selectedAccount().accountId,
      recordCalendarId: Number(value)
    };

    await this.telegramService.attachChatRecordCalenderId(attachChatRecordCalenderIdParams)
      .then(() => {
        this.recordCalendarId = Number(value);
        this.attachRecordCalendarId.emit(this.recordCalendarId);
      });
  }
}
